import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginUser } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const steamLinked = params.get('steam_linked');

    loginUser({}).then(() => {
      if (steamLinked) {
        navigate('/inventory');
      } else {
        navigate('/dashboard');
      }
    }).catch(() => {
      navigate('/login');
    });
  }, [location.search, loginUser, navigate]);

  return (
    <div style={{
      background: '#0a0a0a',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: '16px',
    }}>
      <div style={{
        width: '40px', height: '40px',
        border: '2px solid #1e1e1e',
        borderTop: '2px solid #E8192C',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }}/>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <div style={{
        fontFamily: "'Bebas Neue', sans-serif",
        fontSize: '16px',
        letterSpacing: '4px',
        color: '#333',
      }}>
        LINKING STEAM ACCOUNT...
      </div>
    </div>
  );
}